import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import _get from 'lodash/get';

import { TableHeading } from 'components/Tables';
import { ROUTES } from '../../../../../../stubs';
import { Breadcrumb, Skeleton } from 'components';

export default function Header({ isEditMode = false, data = {} }) {
  const { push } = useHistory();

  const exceptionName = _get(data, 'name', '');
  const title = isEditMode ? exceptionName : 'Create Exception';

  const breadcrumbItems = useMemo(() => {
    return [
      {
        label: 'Configure',
        onClick: () => push(ROUTES.CONFIGURE)
      },
      {
        label: 'Return Management',
        onClick: () => push(ROUTES.RETURN_MANAGEMENT)
      },
      {
        label: 'Return Window',
        onClick: () => push(ROUTES.RETURN_WINDOW)
      },
      {
        label: 'Product SKU Based Return Window',
        onClick: () => push(ROUTES.PRODUCT_SKU_EXCEPTION)
      },
      { label: title, loading: !title }
    ];
  }, [title, push]);

  return (
    <>
      <Breadcrumb items={breadcrumbItems} />
      <TableHeading
        title={
          title || <Skeleton width="300px" height="40px" className="mb-4" />
        }
      />
    </>
  );
}
